import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import { PAProduct } from "./types";

export const paProductListService = (params: {
  keyword?: string | null;
  code?: string | null;
  name?: string | null;
  page?: number | null;
  limit?: number | null;
  status?: number | null;
}) =>
  RestAPIClient.call<RestAPIResponseList<PAProduct>>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const paProductListShortService = (params: {
  keyword?: string | null;
  code?: string | null;
  name?: string | null;
  page?: number | null;
  limit?: number | null;
  status?: number | null;
}) =>
  RestAPIClient.call<RestAPIResponseList<PAProduct>>({
    method: HTTPRequestMethods.GET,
    url: Paths.Short,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const paProductCreateService = (params: {
  code: string;
  name: string;
  nativeName: string;
  description: string;
  nativeDescription: string;
  unit: string;
}) =>
  RestAPIClient.call<PAProduct>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const paProductUpdateService = ({
  id,
  ...rest
}: Parameters<typeof paProductCreateService>[0] & {
  id: string;
  status?: number;
}) =>
  RestAPIClient.call<PAProduct>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${String(id)}`,
    config: {
      requireAuthentication: true,
    },
    data: rest,
  });

export const paProductDetailService = (id: string) =>
  RestAPIClient.call<PAProduct>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const paProductDeleteService = (id: string) =>
  RestAPIClient.call<PAProduct>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Delete}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });
